import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import {
  closeDeleteSpotBiddingRuleModal,
  deleteSpotBiddingRule,
} from 'apps/spot-quote-control-panel/utils/actions/spotBiddingConfig'
import { ConfirmationModal } from 'transfix-ui'

interface IDeleteRuleModalProps {
  showModal: boolean
  ruleId?: string
}

export const DeleteSpotBiddingRuleModal = memo<IDeleteRuleModalProps>(({ ruleId, showModal }) => {
  const dispatch = useDispatch()

  const closeModalHandler = () => {
    dispatch(closeDeleteSpotBiddingRuleModal())
  }

  const deleteRule = () => {
    dispatch(deleteSpotBiddingRule(ruleId))
  }

  return (
    <ConfirmationModal
      title='Delete Rule?'
      size={4}
      open={showModal}
      onClose={closeModalHandler}
      dataTest='modal-delete-spot-bidding-rule'
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          dataTest: 'cancel-delete-spot-bidding-rule-button',
        },
        {
          label: 'Delete Rule',
          type: 'confirm',
          action: deleteRule,
          dataTest: 'delete-spot-bidding-rule-button',
        },
      ]}>
      This action cannot be undone
    </ConfirmationModal>
  )
})
